import { adminHttpClient } from '../../commons/adminHttpClient'
import PagedList from '../../commons/pagedList'
import JobLogStatus from '../../../domain/jobs/JobLogStatus'
import JobType from '../../../domain/jobs/JobType'

export interface PagedJobLogs extends PagedList<JobLogItem> {}

export interface JobLogItem {
  jobName: string
  startedOn: string
  endedOn: string | null
  result: string
  status: { id: JobLogStatus; name: string }
  type: { id: JobType; name: string }
  triggeredBy: string
  description: string
}

export type JobLogFilter = {
  pageNumber: number
  pageSize: number
  orderColumn: string
  orderDescending: boolean
  jobId?: string
  status?: JobLogStatus
  type?: JobType
  ended?: boolean
}

const getJobLogs = (filter: JobLogFilter): Promise<any> => {
  filter = filter || {
    pageNumber: 1,
    pageSize: 10,
    orderColumn: 'startedOn',
    orderDescending: false,
  }

  return adminHttpClient.get('/JobLog', filter)
}

export default getJobLogs
